import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserApiErrorsIntegration(),
  ],
  release: import.meta.env.VITE_APP_VERSION,
});
